<template>
  <printPage class="body" :printForm="postForm"></printPage>
</template>

<script>
  import printPage from './index.vue'

  export default {
    name: 'editForm',
    components: { printPage },
    data() {
      return {
        postForm: {}
      }
    },
    created() {

      this.postForm = JSON.parse(this.$route.query.row)
    },
    methods: {
    }
  }
</script>
<style scoped lang="less">
  .header {
    text-align: right;
    background-color: #fff;
    padding: 0px 20px;
    border-radius: 10px;
    margin-bottom: -20px;
  }

  .body {
    height: 100vh !important;
  }
</style>